<div class="header grid">
  <div class="logo col-4">
    <img src="assets/images/e-medapps.png" height="80px" />
  </div>
  <div
    class="col-12"
    style="
      background-image: linear-gradient(to right, rgb(59, 187, 59), darkgreen);
      height: 30px;
    "
  ></div>
</div>
<p-toast position="bottom-left" key="alertToast"></p-toast>
